import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Theme } from '../../../theme/theme';
import MaterialSelect, { MaterialSelectProps, StyleConfig } from '../../MaterialSelect';

/** Option value type: for options like { value: string, label: string }, this is string */
type OptionValue<T> = T extends { value: infer V } ? V : T;

type Props<T = any> = Omit<MaterialSelectProps<T>, 'styleConfig' | 'onChange'> & {
  /** Called with the selected option's value (e.g. string id), not the full option object */
  onChange?: (value: OptionValue<T>) => void;
  disabled?: boolean;
};

export const Style: StyleConfig = {
  inputBorder: Theme.inputBorder,
  inputBorderHover: Theme.inputBorderHover,
  inputBorderRadius: Theme.inputBorderRadius,
  inputTextColor: Theme.inputTextColor,
  menuBorder: Theme.selectMenuBorder,
  menuBorderRadius: Theme.selectMenuBorderRadius,
};

function FormSelect<T = any>(props: Props<T>) {
  const { value, onChange, ...rest } = props;

  //todo check type for GroupBase<TOption>
  // @ts-ignore
  const selectedOption: SelectOptionBase<T> = value && props?.options?.find((o) => o.value === value);
  const onChangeCB = useCallback((newOption, e) => {
    onChange?.(newOption.value);
  }, []);

  return (
    // @ts-ignore // FIXME: type error
    <MaterialSelect<T>
      {...rest}
      styleConfig={Style}
      defaultValue={selectedOption}
      value={selectedOption}
      onChange={onChangeCB}
      isDisabled={rest.disabled}
    />
  );
}

export default FormSelect;
